import * as React from 'react';
import { useSelector } from 'react-redux';
import { validateAuthentication } from "src/modules/Auth/helpers/validateAuthentication";
import { shouldShowTermsOfUse } from "src/modules/Auth/helpers/shouldShowTermsOfUse";
import { UserTypes } from "src/modules/Auth/store/types";
import { IReduxState } from 'src/reduxTypes';


export const useAuthValidator = (policies: UserTypes[]) => {
  const { userType, termsOfUseStatus } = useSelector((reduxState: IReduxState) => ({
    userType: reduxState.auth.userType,
    termsOfUseStatus: reduxState.auth.termsOfUseStatus
  }));
  const authData = React.useMemo(() => {
    return {
      auth: validateAuthentication(userType, policies),
      showTermsOfUse: shouldShowTermsOfUse(termsOfUseStatus)
    }
  }, [userType, termsOfUseStatus])
  return authData;
}


// WEBPACK FOOTER //
// ./src/modules/Auth/hooks/useAuthValidator.tsx